export const datalabelOptions = {
  plugins: {
    datalabels: {
      display: (context) => (context.dataset.data[context.dataIndex] === 0 ? false : 'auto'),
      color: 'black'

    }
  }
};
